export function validateEmail(email: string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function validatePassword(password: string) {
    const requirements = [
        {test: /[a-z]/, msg: "At least one lowercase letter"},
        {test: /[A-Z]/, msg: "At least one uppercase letter"},
        {test: /\d/, msg: "At least one number"},
        {test: /[@$!%#*?&.]/, msg: "At least one special character"},
        {test: /^.{12,}$/, msg: "Minimum 12 characters long"},
        {test: /^\S+$/, msg: "No spaces or whitespace allowed"}
    ];

    const failed = requirements.filter(r => !r.test.test(password)).map(r => r.msg);

    return {valid: failed.length === 0, errors: failed};
}

const USERNAME_REGEX =
    /^(?=.{3,20}$)[a-z0-9](?!.*[._-]{2})[a-z0-9._-]*[a-z0-9]$/i;

const RESERVED_USERNAMES = [
    'admin',
    'root',
    'system',
    'support',
    'null',
    'undefined',
    'moderator',
    'superuser'
];

export function validateUsername(username: string) {
    const value = username.trim().toLowerCase();
    const errors: string[] = [];

    if (!value) {
        errors.push('Username is required');
    }

    if (value.length < 3 || value.length > 20) {
        errors.push('Username must be between 3 and 20 characters');
    }

    if (!USERNAME_REGEX.test(value)) {
        errors.push(
            'Only letters, numbers, ".", "_" and "-" allowed. No consecutive symbols.'
        );
    }

    if (RESERVED_USERNAMES.includes(value)) {
        errors.push('This username is reserved');
    }

    return {
        valid: errors.length === 0,
        errors
    };
}